import type {
  ExternalCourse,
  ExternalCourseEditPayload,
  FineUploaderUpload,
  Institution,
  StudentEditSubmissionDeleteExternalCourseRequest,
} from './api'
import { displayInstitution } from './display'

export type ExternalCourseModalFormState = {
  currentExternalCourse: ExternalCourse | null
  externalCourseInstitution: Institution | null
  externalCourseInstitutionName: string | undefined
  institutionSearchText: string
  externalCourseName: string
  externalCourseCode: string
  externalCourseLevelId: string
  externalCourseCompletedYear: string
}

export type CustomInstitutionState = {
  externalCourseInstitution: Institution
  externalCourseInstitutionName: string
  institutionSearchText: string
}

export const externalCourseDeleteConfirmationMessage = 'Are you sure you want to remove this course?'

export function externalCourseForEdit(course: ExternalCourse): ExternalCourse {
  return {
    ...course,
    external_course_institution: course.external_course_institution ?? { name: course.external_course_institution_name },
  }
}

export function initialExternalCourseModalFormState(course: ExternalCourse | null): ExternalCourseModalFormState {
  const externalCourseInstitution = course?.external_course_institution ?? null

  return {
    currentExternalCourse: course,
    externalCourseInstitution,
    externalCourseInstitutionName: course?.external_course_institution_name,
    institutionSearchText: displayInstitution(externalCourseInstitution),
    externalCourseName: course?.external_course_name ?? '',
    externalCourseCode: course?.external_course_code ?? '',
    externalCourseLevelId: course?.external_course_level_id == null ? '' : String(course.external_course_level_id),
    externalCourseCompletedYear: course?.external_course_completed_year == null ? '' : String(course.external_course_completed_year),
  }
}

export function customInstitutionState(institutionName: string): CustomInstitutionState {
  return {
    externalCourseInstitution: { name: institutionName },
    externalCourseInstitutionName: institutionName,
    institutionSearchText: institutionName,
  }
}

export function buildExternalCourseEditPayload(args: {
  existingCourse: ExternalCourse | null
  externalCourseInstitution: Institution | null
  externalCourseInstitutionName: string | undefined
  deleteAttachmentIds: number[]
  newAttachments: FineUploaderUpload[]
  externalCourseName: string
  externalCourseCode: string
  externalCourseLevelId: string
  externalCourseCompletedYear: string
}): ExternalCourseEditPayload {
  const externalCoursePayload: ExternalCourseEditPayload = {
    ...args.existingCourse,
    external_course_institution: args.externalCourseInstitution,
    delete_attachments: args.deleteAttachmentIds,
    new_attachments: args.newAttachments,
    external_course_name: args.externalCourseName,
    external_course_code: args.externalCourseCode,
    external_course_level: args.externalCourseLevelId,
    external_course_completed_year: args.externalCourseCompletedYear,
    my_e_quals: 0,
    external_course_level_id: args.externalCourseLevelId,
  }

  if (args.externalCourseInstitutionName !== undefined) {
    externalCoursePayload.external_course_institution_name = args.externalCourseInstitutionName
  }

  return externalCoursePayload
}

export function buildExternalCourseDeleteRequest(
  secureData: string,
  externalCourseId: number,
): StudentEditSubmissionDeleteExternalCourseRequest {
  return {
    secure_data: secureData,
    delete_external_course_id: externalCourseId,
  }
}
